import {
    Box,
    Button,
    Checkbox,
    FormControl,
    Grid,
    InputLabel,
    MenuItem,
    Select,
    Switch,
    Tooltip,
    TextField,
    Chip,
    Autocomplete,
} from '@mui/material'
import React, {
    useCallback,
    useContext,
    useEffect,
    useState,
    useRef,
} from 'react'
import { Input } from '../../components/StyleComponent'
import { useForm, Controller } from 'react-hook-form'
import { urlConfig } from '../../config/apiConfig'
import { useTimezoneSelect, allTimezones } from 'react-timezone-select'
import axiosInstance from '../../config/axiosConfig'
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined'
import { useNavigate } from 'react-router-dom'
import EditOutlinedIcon from '@mui/icons-material/EditOutlined'
import SaveAltOutlinedIcon from '@mui/icons-material/SaveAltOutlined'
import CloseRoundedIcon from '@mui/icons-material/CloseRounded'
import ModalDeleteOrg from './DeleteOrg'
import { DatePicker } from '@mui/x-date-pickers'
import dayjs from 'dayjs'
import { AlertContext } from '../../context/AlertContext'
import SoundSetting from './SoundSetting'
import Volumnn from '../../components/icons/Voulumn'
import VolumnMute from '../../components/icons/VolumnMute'

export default function Setting({ keyName, handleAlert, remove, update }) {
    const [data, setData] = useState('')
    const [enableData, setEnableData] = useState(false)
    const { handleSubmit, control, setValue, watch } = useForm()
    const [open, setOpen] = useState(false)
    const [edit, setEdit] = useState(false)
    const [exStatus, setExStatus] = useState(false)
    const [openSetting, setOpenSetting] = useState(false)
    const [active, setAcitve] = useState(false)
    const [loading, setLoading] = useState(false)

    const [inputValue, setInputValue] = useState('')
    const timeoutRef = useRef(null)

    const navigate = useNavigate()
    const labelStyle = 'original'
    const timezones = {
        ...allTimezones,
        'Europe/Berlin': 'Frankfurt',
    }
    const { options } = useTimezoneSelect({
        labelStyle,
        timezones,
    })

    const validateEmail = (email) => {
        const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/
        return emailRegex.test(email)
    }

    const handleEmailChange = (newValue, onChange) => {
        const uniqueValidEmails = Array.from(
            new Set(newValue.filter(validateEmail)),
        )
        onChange(uniqueValidEmails)
    }

    // useEffect(() => {
    //     return () => {
    //         if (timeoutRef.current) {
    //             clearTimeout(timeoutRef.current)
    //         }
    //     }
    // }, [])

    const { handleOpen } = useContext(AlertContext)

    const getOrg = useCallback(async () => {
        try {
            const res = await axiosInstance(
                `${urlConfig.organization}/${keyName}`,
            )
            setData(res.data.message)
            setAcitve(res.data.message?.status === 'Active' || false)
            setExStatus(!!res.data.message?.expire_date)
            Object.keys(res.data.message).forEach((key) => {
                if (key === 'expire_date') {
                    const expireDate = res.data.message[key]
                    if (expireDate) {
                        setValue(key, extractDate(expireDate))
                    } else {
                        setValue(key, null)
                    }
                } else {
                    setValue(key, res.data.message[key])
                }
            })
            handleOpen({ open: false })
        } catch (error) {
            handleOpen({
                open: true,
                message: `${error.response?.data.message}`,
                isSuccess: false,
            })
        }
    }, [keyName, setValue])

    const getData = useCallback(async () => {
        try {
            const res = await axiosInstance.get(urlConfig.lineOA)
            if (res.data.message && res.data.message.length > 0) {
                const filteredData = res.data.message.filter(
                    (item) => item.keyName === keyName,
                )

                setEnableData(filteredData[0].enable_line_oa)
            }
        } catch (error) {}
    }, [keyName])

    const onSubmit = async (data) => {
        const body = {
            ...data,
            expire_date: exStatus
                ? dayjs(data.expire_date, 'DD/MM/YYYY').format('YYYY-MM-DD')
                : null,
            status: active ? 'Active' : 'Inactive',
        }

        if (exStatus && body.expire_date === 'Invalid Date') {
            handleAlert('Please select a valid expire date', 'error')
            return
        }
        setLoading(true)

        try {
            // await axiosInstance.put(`${urlConfig.lineOA}/keyName/${keyName}`, {
            //     enable_line_oa: enableData,
            // })

            const response = await axiosInstance.put(
                `${urlConfig.organization}/${keyName}`,
                body,
            )
            if (response.status === 200) {
                handleAlert('Setting organization', 'success')
                getOrg()
            } else {
                handleAlert('Failed to update the Organization', 'error')
            }
        } catch (err) {
            console.error('Error caught:', err)
            handleAlert('Failed to update the Organization', 'error')
        } finally {
            setLoading(false)
            getData()
        }
    }

    useEffect(() => {
        getData()
        getOrg()
    }, [getOrg, getData])

    const deleteRole = async () => {
        setLoading(true)
        try {
            await axiosInstance.delete(`${urlConfig.organization}/${keyName}`)
            setOpen(false)
            handleAlert('Organization delete successfully.', 'success')

            navigate('/organizations')
        } catch {
            handleAlert('Failed to delete the organization', 'error')
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        if (data) {
            Object.keys(data).forEach((key) => {
                if (key === 'expire_date') {
                    setValue(key, dayjs(data[key]))?.format('DD/MM/YYYY')
                }
            })
        }
    }, [data, setValue])

    return (
        <React.Fragment>
            <form onSubmit={handleSubmit(onSubmit)}>
                <Grid
                    container
                    spacing={3}
                    sx={{
                        padding: '20px',
                    }}
                >
                    <Grid
                        item
                        xs={12}
                        sx={{
                            display: 'flex',
                            justifyContent: 'space-between',
                        }}
                    >
                        <Box sx={{ fontWeight: 'bold', fontSize: '24px' }}>
                            <span>General&#160;</span>

                            <Button
                                color='buttonSave'
                                variant='contained'
                                size='small'
                                sx={{
                                    fontSize: '12px',
                                    // textTransform: 'none',
                                    borderRadius: '15px',
                                    mx: 1,
                                    height: '30px',
                                }}
                                onClick={() => setOpenSetting(true)}
                            >
                                <Box
                                    sx={{
                                        marginRight: '5px',
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                    }}
                                >
                                    {data?.enable_sound ? (
                                        <Volumnn />
                                    ) : (
                                        <VolumnMute />
                                    )}
                                </Box>
                                Notification sound
                            </Button>
                            <span
                                style={{
                                    fontWeight: '400',
                                    fontSize: '14px',
                                    color: 'green',
                                }}
                            >
                                {edit && '[ EDIT MODE ]'}
                            </span>
                        </Box>
                        <Box
                            sx={{
                                whiteSpace: 'nowrap',
                                display: 'flex',
                                gap: 0.5,
                                alignItems: 'center',
                            }}
                        >
                            {!edit && (
                                <Tooltip title='Delete organization'>
                                    <Button
                                        sx={{
                                            borderRadius: '25px',
                                            // textTransform: 'none',
                                            height: '33px',
                                            // fontWeight: '500',
                                            fontSize: '14px',
                                            backgroundColor: '#DA1C23',
                                            color: 'white',
                                            px: 2.5,
                                            boxShadow:
                                                '0px 3px 6px rgba(0,0,0,0.16)',
                                            '&:hover': {
                                                backgroundColor: '#C62828',
                                                boxShadow:
                                                    '0px 5px 10px rgba(0,0,0,0.2)',
                                            },
                                            '&:disabled': {
                                                backgroundColor: '#BDBDBD',
                                                color: '#E0E0E0',
                                            },
                                        }}
                                        variant='contained'
                                        size='medium'
                                        startIcon={
                                            <DeleteOutlineOutlinedIcon />
                                        }
                                        onClick={() => setOpen(true)}
                                        disabled={!remove}
                                    >
                                        DELETE
                                    </Button>
                                </Tooltip>
                            )}
                            <Box
                                sx={{
                                    display: 'flex',
                                    alightItems: 'center',
                                    gap: 1,
                                }}
                            >
                                {edit && (
                                    <Button
                                        variant='contained'
                                        startIcon={<CloseRoundedIcon />}
                                        sx={{
                                            borderRadius: '25px',
                                            // textTransform: 'none',
                                            height: '33px',
                                            // fontWeight: '400',
                                            fontSize: '14px',
                                            px: 2.5,
                                            backgroundColor: '#DA1C23',
                                            color: 'white',
                                            boxShadow:
                                                '0px 3px 6px rgba(0,0,0,0.16)',
                                            '&:hover': {
                                                backgroundColor: '#C62828',
                                                boxShadow:
                                                    '0px 5px 10px rgba(0,0,0,0.2)',
                                            },
                                        }}
                                        onClick={() => {
                                            setEdit(false)
                                            getOrg()
                                        }}
                                    >
                                        Cancel
                                    </Button>
                                )}
                                {edit && (
                                    <Button
                                        sx={{
                                            borderRadius: '25px',
                                            // textTransform: 'none',
                                            height: '33px',
                                            fontSize: '14px',
                                            px: 2.5,
                                            backgroundColor: '#73BE30',
                                            color: 'white',
                                            boxShadow:
                                                '0px 3px 6px rgba(0,0,0,0.16)',
                                            '&:hover': {
                                                backgroundColor: '#388E3C',
                                                boxShadow:
                                                    '0px 5px 10px rgba(0,0,0,0.2)',
                                            },
                                            '&:disabled': {
                                                backgroundColor: '#BDBDBD',
                                                color: '#E0E0E0',
                                            },
                                        }}
                                        variant='contained'
                                        type={'submit'}
                                        disabled={loading}
                                        startIcon={<SaveAltOutlinedIcon />}
                                    >
                                        Save
                                    </Button>
                                )}
                            </Box>
                            {!edit && (
                                <Tooltip title='Edit organization'>
                                    <Button
                                        disabled={!update}
                                        sx={{
                                            borderRadius: '25px',
                                            // textTransform: 'none',
                                            height: '33px',
                                            // fontWeight: '500',
                                            fontSize: '14px',
                                            px: 2.5,
                                            backgroundColor: '#FDA655',
                                            color: 'white',
                                            boxShadow:
                                                '0px 3px 6px rgba(0,0,0,0.16)',
                                            '&:hover': {
                                                backgroundColor: '#EF6C00',
                                                boxShadow:
                                                    '0px 5px 10px rgba(0,0,0,0.2)',
                                            },
                                            '&:disabled': {
                                                backgroundColor: '#BDBDBD',
                                                color: '#E0E0E0',
                                            },
                                        }}
                                        variant='contained'
                                        size='medium'
                                        startIcon={<EditOutlinedIcon />}
                                        onClick={() => setEdit(true)}
                                    >
                                        EDIT
                                    </Button>
                                </Tooltip>
                            )}
                        </Box>
                    </Grid>

                    <Grid item xs={12}>
                        {((data && data.status === 'Inactive') ||
                            data.status === 'Expired') && (
                            <Box sx={{ color: 'red' }}>
                                the organization's usage has expired
                            </Box>
                        )}
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <Controller
                            name='site_name'
                            control={control}
                            defaultValue={data?.site_name || ''}
                            render={({ field: { value, onChange } }) => (
                                <Input
                                    label='Customer Name (Organization name)'
                                    required
                                    value={value || ''}
                                    onChange={onChange}
                                    readOnly={!edit}
                                />
                            )}
                        />
                    </Grid>

                    <Grid item xs={12} md={4}>
                        <Controller
                            name='keyName'
                            control={control}
                            defaultValue={data?.keyName || ''}
                            render={({ field: { value, onChange } }) => (
                                <Input
                                    label='KeyName'
                                    required
                                    value={value || ''}
                                    onChange={onChange}
                                    readOnly={true}
                                    // readOnly={!edit}
                                />
                            )}
                        />
                    </Grid>
                    <Grid
                        item
                        xs={12}
                        md={4}
                        sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                        }}
                    >
                        <DatePicker
                            sx={{
                                width: '100%',
                            }}
                            name='expire_date'
                            label='Expire Date'
                            InputLabelProps={{ shrink: true }}
                            slotProps={{ textField: { size: 'small' } }}
                            value={
                                watch('expire_date')
                                    ? dayjs(watch('expire_date'), 'DD/MM/YYYY')
                                    : null
                            }
                            format='DD/MM/YYYY'
                            disabled={!edit || !exStatus}
                            onChange={(date) => {
                                setValue(
                                    'expire_date',
                                    date ? date.format('DD/MM/YYYY') : '',
                                )
                            }}
                        />
                        <Checkbox
                            checked={exStatus}
                            disabled={!edit}
                            onChange={(_, nv) => setExStatus(nv)}
                            sx={
                                {
                                    // color: '#1976D2',
                                    // '&.Mui-checked': {
                                    //     color: '#1976D2',
                                    // },
                                    // '&.Mui-disabled': {
                                    //     color: '#BDBDBD',
                                    // },
                                }
                            }
                        />
                    </Grid>

                    <Grid item xs={12} md={4}>
                        <Controller
                            name='latitude'
                            control={control}
                            defaultValue={data?.latitude || ''}
                            render={({ field }) => (
                                <Input
                                    label='Lattitude'
                                    required
                                    type='number'
                                    value={field.value || ''}
                                    onChange={(e) => {
                                        let value = e.target.value
                                        if (value === '-' || value === '') {
                                            field.onChange(value)
                                            return
                                        }
                                        const regex = /^-?\d*(\.\d{0,5})?$/
                                        if (regex.test(value)) {
                                            let parsedValue = parseFloat(value)
                                            if (!isNaN(parsedValue)) {
                                                if (parsedValue > 90) {
                                                    parsedValue = 90
                                                } else if (parsedValue < -90) {
                                                    parsedValue = -90
                                                }
                                            }

                                            field.onChange(
                                                parsedValue ||
                                                    (value === '.' && value),
                                            )
                                        }
                                    }}
                                    readOnly={!edit}
                                />
                            )}
                        />
                    </Grid>

                    <Grid item xs={12} md={4}>
                        <Controller
                            name='longitude'
                            control={control}
                            defaultValue={data?.longitude || ''}
                            render={({ field }) => (
                                <Input
                                    label='Longitude'
                                    required
                                    type='number'
                                    value={field.value || ''}
                                    onChange={(e) => {
                                        let value = e.target.value
                                        if (value === '-' || value === '') {
                                            field.onChange(value)
                                            return
                                        }
                                        const regex = /^-?\d*(\.\d{0,5})?$/
                                        if (regex.test(value)) {
                                            let parsedValue = parseFloat(value)
                                            if (!isNaN(parsedValue)) {
                                                if (parsedValue > 180) {
                                                    parsedValue = 180
                                                } else if (parsedValue < -180) {
                                                    parsedValue = -180
                                                }
                                            }

                                            field.onChange(
                                                parsedValue ||
                                                    (value === '.' && value),
                                            )
                                        }
                                    }}
                                    readOnly={!edit}
                                />
                            )}
                        />
                    </Grid>

                    <Grid item xs={12} md={4}>
                        <FormControl fullWidth size='small'>
                            <InputLabel id='timezone-label'>
                                TimeZone
                            </InputLabel>
                            <Controller
                                name='timezone'
                                control={control}
                                defaultValue=''
                                render={({ field: { value, onChange } }) => (
                                    <Select
                                        disabled={!edit}
                                        labelId='timezone-label'
                                        label='TimeZone'
                                        value={value || ''}
                                        onChange={onChange}
                                    >
                                        {options.map((option) => (
                                            <MenuItem
                                                key={option.value}
                                                value={option.value}
                                            >
                                                {option.label}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                )}
                            />
                        </FormControl>
                    </Grid>

                    <Grid item xs={12} md={12}>
                        <Controller
                            name='address'
                            control={control}
                            defaultValue={data?.address || ''}
                            render={({ field: { value, onChange } }) => (
                                <Input
                                    label='Address'
                                    required
                                    value={value || ''}
                                    onChange={onChange}
                                    readOnly={!edit}
                                    rows={4}
                                    multiline
                                />
                            )}
                        />
                    </Grid>

                    <Grid item xs={12}>
                        <Controller
                            name='phone_number'
                            control={control}
                            defaultValue={data?.phone_number || ''}
                            render={({ field: { value = '', onChange } }) => (
                                <Input
                                    label='Phone Number'
                                    //required
                                    value={value || ''}
                                    onChange={onChange}
                                    readOnly={!edit}
                                />
                            )}
                        />
                    </Grid>

                    <Grid item xs={12}>
                        <Controller
                            name='group_line_id'
                            control={control}
                            defaultValue={data?.group_line_id || ''}
                            render={({ field: { value, onChange } }) => (
                                <Input
                                    label='Line Group ID'
                                    onChange={onChange}
                                    // required
                                    value={value || ''}
                                    readOnly={!edit}
                                />
                            )}
                        />
                    </Grid>

                    <Grid item xs={12}>
                        <Controller
                            name='email'
                            control={control}
                            defaultValue={
                                Array.isArray(data?.email) ? data.email : []
                            }
                            render={({ field: { value, onChange } }) => {
                                // Helper function to try adding an email
                                const tryAddEmail = (input) => {
                                    if (
                                        input &&
                                        validateEmail(input) &&
                                        Array.isArray(value) &&
                                        !value.includes(input)
                                    ) {
                                        const updated = [...value, input]
                                        handleEmailChange(updated, onChange)
                                        return true
                                    }
                                    return false
                                }

                                return (
                                    <Autocomplete
                                        multiple={true}
                                        freeSolo
                                        id='email-autocomplete'
                                        value={
                                            Array.isArray(value) ? value : []
                                        }
                                        inputValue={inputValue}
                                        onInputChange={(event, newValue) => {
                                            setInputValue(newValue)

                                            // Clear any existing timeout
                                            if (timeoutRef.current) {
                                                clearTimeout(timeoutRef.current)
                                            }

                                            // Set a new timeout to check after user stops typing
                                            if (
                                                newValue &&
                                                newValue.includes('@') &&
                                                newValue.includes('.')
                                            ) {
                                                timeoutRef.current = setTimeout(
                                                    () => {
                                                        if (
                                                            tryAddEmail(
                                                                newValue,
                                                            )
                                                        ) {
                                                            setInputValue('')
                                                        }
                                                    },
                                                    750,
                                                ) // Wait 750ms after typing stops
                                            }
                                        }}
                                        onChange={(event, newValue) => {
                                            handleEmailChange(
                                                newValue,
                                                onChange,
                                            )
                                        }}
                                        filterSelectedOptions
                                        options={[]}
                                        renderTags={(value, getTagProps) =>
                                            value.map((option, index) => {
                                                const { key, ...tagProps } =
                                                    getTagProps({ index })
                                                return (
                                                    <Chip
                                                        key={key}
                                                        variant='outlined'
                                                        label={option}
                                                        {...tagProps}
                                                    />
                                                )
                                            })
                                        }
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                label='Email'
                                                size='small'
                                                onKeyDown={(event) => {
                                                    if (
                                                        event.key === 'Enter' ||
                                                        event.key === ','
                                                    ) {
                                                        event.preventDefault()
                                                        const input =
                                                            event.target.value.trim()
                                                        if (
                                                            tryAddEmail(input)
                                                        ) {
                                                            setInputValue('')
                                                        }
                                                    }
                                                }}
                                                onBlur={() => {
                                                    // Also try to add email when field loses focus
                                                    if (inputValue.trim()) {
                                                        tryAddEmail(
                                                            inputValue.trim(),
                                                        )
                                                        setInputValue('')
                                                    }
                                                }}
                                            />
                                        )}
                                        disabled={!edit}
                                    />
                                )
                            }}
                        />
                    </Grid>

                    <Grid item xs={12} md={12} align='right'>
                        <span style={{ fontWeight: 'bold', fontSize: '14px' }}>
                            ACTIVE
                        </span>{' '}
                        <Switch
                            color='success'
                            checked={active}
                            disabled={!edit}
                            onChange={(_, nv) => setAcitve(nv)}
                        />
                    </Grid>
                    <Grid item xs={12} md={12} align='right'>
                        <span style={{ fontWeight: 'bold', fontSize: '14px' }}>
                            LINE OA
                        </span>
                        <Switch
                            color='success'
                            checked={enableData}
                            disabled={!edit}
                            onChange={async (_, nv) => {
                                setEnableData(nv)
                                try {
                                    await axiosInstance.put(
                                        `${urlConfig.lineOA}/keyName/${keyName}`,
                                        { enable_line_oa: nv },
                                    )
                                    // handleAlert(
                                    //     'LINE OA updated successfully',
                                    //     'success',
                                    // )
                                } catch (error) {
                                    // handleAlert(
                                    //     'Failed to update LINE OA',
                                    //     'error',
                                    // )
                                    setEnableData(!nv)
                                }
                            }}
                        />
                    </Grid>
                </Grid>
            </form>

            <SoundSetting
                row={data}
                open={openSetting}
                setOpen={setOpenSetting}
                handleAlert={handleAlert}
                refresh={getOrg}
            />
            <ModalDeleteOrg
                disabled={loading}
                onSubmit={deleteRole}
                open={open}
                setOpen={setOpen}
                message={`${keyName}`}
                data={data || ''}
            />
        </React.Fragment>
    )
}
function extractDate(datetime) {
    return datetime.split('T')[0]
}
